import { render, staticRenderFns } from "./NgImage.vue?vue&type=template&id=3aa34923&scoped=true&"
import script from "./NgImage.vue?vue&type=script&lang=js&"
export * from "./NgImage.vue?vue&type=script&lang=js&"
import style0 from "./NgImage.vue?vue&type=style&index=0&id=3aa34923&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa34923",
  null
  
)

export default component.exports